import React, { ReactNode } from "react";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";

interface Props {
  title: string;
  onClick: () => void;
  icon: ReactNode;
}

const IconButtonWithTooltip: React.FC<Props> = ({ title, onClick, icon }) => {
  return (
    <Tooltip title={title}>
      <IconButton onClick={onClick}>{icon}</IconButton>
    </Tooltip>
  );
};

export default IconButtonWithTooltip;
